// extracted by mini-css-extract-plugin
module.exports = {"auth":"AuthForm_auth__232mu","control":"AuthForm_control__1pLw9","actions":"AuthForm_actions__rNnwd","toggle":"AuthForm_toggle__3OPMQ"};